/* eslint-disable camelcase */
import {ServiceFactory, CancelToken} from 'api';
import {applyFilter} from './helpers';

const Service = ServiceFactory();

const jsonBody = {
  q: null,
  filters: {},
};

// Do an API search request. This gets a list of candidate IDs matching the search
// filters provided.
export const search = (filters, sort, cancel) => {
  const requestBody = {...jsonBody};

  /* eslint-disable fp/no-mutation */

  const {sortCriteria, ...remainingFilters} = filters;

  requestBody.q = remainingFilters.fullname ?? remainingFilters.fullnameOrKeywords ?? null;

  requestBody.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  requestBody.filters = Object.entries(remainingFilters).reduce((nextFilters, [name, filter]) => {
    if (name === 'fullname') return nextFilters;
    if (name === 'fullnameOrKeywords') return nextFilters;

    if (filter) {
      // eslint-disable-next-line no-param-reassign
      nextFilters[name] = applyFilter(name, filter);
    }

    return nextFilters;
  }, {});

  /* eslint-enable fp/no-mutation */

  // May need to confirm default filters:
  // Status active, practicing true, doNotApproach true.

  // TODO: Sort in candidate search results.

  // eslint-disable-next-line fp/no-mutation
  requestBody.withOrder = sortCriteria || [];

  const Result = Service.post(`approaches/search`, requestBody, {
    cancelToken: cancel ? new CancelToken(cancel) : undefined,
  });

  return Result;
};
